import { deepClone } from '../../../Utility/DeepClone';
import { QuoteTemplateData } from '../../../Widget/QuoteWidget/types';
import { RawTemplate } from '../../types';
import { VueTemplate } from '../VueTemplate';

/**
 * Template class for quote templates created using Vue
 */
export class VueQuoteTemplate extends VueTemplate<QuoteTemplateData> {
    /**
     * Expected format of the dataStore
     *
     * All dataStore for Content template must be of this format so that
     * templates are consistent
     * @see [Vue Prop Validation]{@link https://vuejs.org/v2/guide/components-props.html#Prop-Validation}
     */
    properties: {
        quoteArray: ArrayConstructor;
        quotes: ObjectConstructor;
        widget: ObjectConstructor;
        metadata: ObjectConstructor;
    } = {
        //Array of quotes
        quoteArray: Array,

        //quotes object
        quotes: Object,

        //reference to the widget object
        widget: Object,

        //Other miscellaneous data
        metadata: Object,
    };

    constructor(template: RawTemplate, wrapper: HTMLElement) {
        super(template, wrapper);
    }

    /**
     * Updates data store with updated list of quotes
     */
    updateDataStore(context: QuoteTemplateData): void {
        const newQuotes: Set<number> = new Set();
        const removedQuotes: Set<number> = new Set();

        // Find new quotes
        context.quoteArray.forEach((quote) => {
            const foundIndex = this.dataStore.quoteArray.findIndex((dsQuote) => {
                return quote.id === dsQuote.id;
            });

            if (foundIndex === -1) {
                newQuotes.add(quote.id);
            }
        });

        // Find removed quotes
        this.dataStore.quoteArray.forEach((dsQuote) => {
            const foundIndex = context.quoteArray.findIndex((quote) => {
                return quote.id === dsQuote.id;
            });

            if (foundIndex === -1) {
                removedQuotes.add(dsQuote.id);
            }
        });

        // Remove old quotes
        removedQuotes.forEach((quoteId) => {
            const foundIndex = this.dataStore.quoteArray.findIndex((quote) => {
                return quoteId === quote.id;
            });

            if (foundIndex === -1) {
                this.dataStore.quoteArray.splice(foundIndex, 1);
            }
        });

        // Add new quotes
        newQuotes.forEach((quoteId) => {
            const foundQuote = context.quoteArray.find((quote) => {
                return quoteId === quote.id;
            });

            if (foundQuote) {
                this.dataStore.quoteArray.push(deepClone(foundQuote));
            }
        });
    }
}
